/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2023, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */

"use strict";

/*let observer;
$(function() {
	observer = lozad('.lozad');
	observer.observe();
});*/

$(() => {
	// "шапка" при скролле и показ/скрытие меню
	const
		header = document.querySelector('.main-header');
	let
		allowSticky = true,
		isSticky = false;

	const stickyHandler = () => {
		if (allowSticky) {
			isSticky = window.scrollY > 0;
			if (isSticky) {
				header.classList.add('is-sticky');
			} else {
				header.classList.remove('is-sticky');
			}
		}
	};
	window.addEventListener('scroll', stickyHandler, true);
	stickyHandler();
});

$(() => {
	// кнопка "Перемотать наверх"
	const element = document.getElementById('rewind-button');
	if(element) {
		const classes = element.classList;
		const handler = () => {
		//let isOpen = element.classList.contains('is-visible');
			if (window.scrollY > 300) {
				classes.add('is-visible');
			} else {
				classes.remove('is-visible');
			}
		};
		window.addEventListener('scroll', handler, true);
		handler();
	}
});

$(() => {
	if(typeof $.fn.lightGallery !== "undefined") {
		// лайтбокс для фотографий в тексте статьи
		const content = $('.main-article');
		if(content) {
			content.lightGallery({
				selector: 'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[rel="lightgallery"]',
				share: false,
				rotate: false,
				download: false,
				preload: false
			});
			content.on('onBeforeOpen.lg', (evt) => {
				console.log(evt);
				reachGoal('image-zoom');
			});
		}
	}
});

/**
 * Заполнение email из поля login при напоминании пароля
 */
$(() => {
	$('#account-remember-link').on('click', function (evt) {
		let email = $('input[name="LoginForm[login]"]').val();
		if (email) {
			evt.preventDefault();
			var url = new URL($(this).attr('href'), window.location.href);
			url.searchParams.set('email', email);
			window.location.href = url.toString();
		}
	});
});

$(() => {
	/* Главное меню */
	const toggler = document.getElementById('menu-toggle');
	const offcanvas = document.getElementById('main-side-panel');
	const backdrop = document.getElementById('main-side-backdrop');
	const closer = offcanvas.querySelector('.closer');
	const toggle = () => {
		offcanvas.classList.toggle('is-open');
		backdrop.classList.toggle('is-open');
	};
	const remove = () => {
		offcanvas.classList.remove('is-open');
		backdrop.classList.remove('is-open');
	};

	toggler.addEventListener('click', evt => {
		evt.preventDefault();
		toggle();
	});
	backdrop.addEventListener('click', evt => {
		evt.preventDefault();
		remove();
	});
	closer.addEventListener('click', evt => {
		evt.preventDefault();
		remove();
	});
	offcanvas.addEventListener('click', evt => {
		let target = evt.target;
		if(target.matches('.js-menuSubTggl')) {
			target.classList.toggle('is-open');
			target.closest('.aside-menu__title').nextElementSibling.classList.toggle('is-open');
		}
	}, true);
	// открываем текущий раздел
	let url = new URL(document.URL);
	if(url.pathname) {
		const parts = url.pathname.split('/').filter(el => !!el);
		if(parts) {
			const event = new MouseEvent("click");
			parts.pop();
			while (parts.length) {
				let path = '/' + parts.join('/') + '/';
				let current = offcanvas.querySelector(`.aside-menu a[href="${path}"]`);
				let parent = current.closest('li');
				parent.querySelector('.js-menuSubTggl').dispatchEvent(event);
				parts.pop();
			}
		}
	}
});

/* Тизер на главной странице */
$(() => {
	if(document.querySelector('.js-introVidSlider')) {
		new Swiper('.js-introVidSlider', {
			simulateTouch: false,
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
		});
	}
});
/* Отзывы на главной странице */
$(() => {
	if(document.getElementById('index-feedbacks')) {
		new Swiper('#index-feedbacks', {
			simulateTouch: false,
			slidesPerView: 1,
			spaceBetween: 20,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			/**
			 *   xs: 0,
			 *   sm: 576px,
			 *   md: 768px,
			 *   lg: 992px,
			 *   xl: 1200px,
			 *   xxl: 1400px
			 */
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		});
		if (typeof $.fn.lightGallery !== "undefined") {
			const content = $('#index-feedbacks');
			content.lightGallery({
				selector: 'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[rel="lightgallery"]',
				share: false,
				rotate: false,
				download: false,
				preload: false
			});
			content.on('onBeforeOpen.lg', (evt) => {
				reachGoal('image-zoom');
			});
		}
	}
});
$(() => {
	const promises = [];
	$('article.main-article .block-carousel').each((i, v) => {
		const carousel = $(v);
		let title = carousel.find('.carousel-title');
		let content = carousel.find('.carousel-content');
		if (0 === title.children().length && /^\s*$/.test(title.text())) {
			// убираем пустой заголовок
			title.remove();
		}
		if (1 === title.children().length) {
			// убираем пустой параграф в заголовке
			if ('&nbsp;' === title.children().first().html()) {
				title.remove();
			}
		}
		let wrapper = $('<div class="swiper"></div>');
		wrapper.append(content);
		carousel.append(wrapper);
		content.addClass('swiper-wrapper');
		const figures = content.find('figure');
		figures.addClass('swiper-slide');
		content.after('<div class="swiper-pagination"></div>');
		content.after('<div class="swiper-button-prev"></div>');
		content.after('<div class="swiper-button-next"></div>');

		const rotator = new Swiper(wrapper.get(0), {
			simulateTouch: false,
			slidesPerView: 1,
			spaceBetween: 0,
			autoHeight: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
		});

		promises.push(
			Promise.allSettled(Array.from(figures.find('img[itemprop="thumbnail"]')).map(img =>
				new Promise(resolve => {
					if (img.complete) {
						resolve({p: i, img: img, src: img.src, state: true});
					} else {
						img.addEventListener('load', () => resolve({p: i, img: img, src: img.src, state: true}));
						img.addEventListener('error', () => resolve({p: i, img: img, src: img.src, state: false}));
					}
				})
			)).then(result => {
				rotator.updateSize();
			}).catch(e => {
				console.log(e);
			})
		);
	});
});
/**
 * Регистрируем начало просмотра видео RuTube как цель в метрике
 * @link https://github.com/rutube/RutubePlayerJSAPI
 */
$(function() {
	let videos = $document.find('figure.responsive-video[data-video^="https://rutube.ru/"]');
	if(videos.length) {
		window.addEventListener('message', (event) => {
			if (event.origin !== 'https://rutube.ru') {
				return;
			}
			try {
				const message = JSON.parse(event.data);
				if (message.type === 'player:playStart') {
					let video = message.data.video_id ? 'https://rutube.ru/video/' + message.data.video_id + '/' : ''
					reachGoal('video-start-play', video)
				}
			} catch(e) {}
		}, true);
	}
});
